import http from "../utils/http";
import { WB_STICKER_SIZE_MM } from "../config/wbStickerPrint";

export async function fetchWbStickers(orderIds, params = {}) {
  const query = {
    type: params.type || "svg",
    width: params.width || WB_STICKER_SIZE_MM.width,
    height: params.height || WB_STICKER_SIZE_MM.height,
  };

  const res = await http.post(
    "/postings/wb-stickers",
    { orders: orderIds },
    { params: query },
  );

  return res.data;
}

export default fetchWbStickers;
